const natureRenderer = "nature-renderer";
const software = "software";
const platforms = "platforms";

export type EntitlementCollection = string[];

export const entitlements = {
    natureRenderer: {
        software: {
            access: `${natureRenderer}.${software}.access`
        },
        platforms: {
            // PC
            windows: `${natureRenderer}.${platforms}.windows`,
            mac: `${natureRenderer}.${platforms}.mac`,
            linux: `${natureRenderer}.${platforms}.linux`,

            // Mobile
            android: `${natureRenderer}.${platforms}.android`,
            iOS: `${natureRenderer}.${platforms}.ios`,

            // Console
            xbox: `${natureRenderer}.${platforms}.xbox`,
            playStation: `${natureRenderer}.${platforms}.playstation`,
            switch: `${natureRenderer}.${platforms}.switch`
        }
    }
};
